import styled from 'styled-components';
export var FooterNotesBlock = styled.div.withConfig({
  displayName: "partials__FooterNotesBlock",
  componentId: "sc-1thxed7-0"
})(["", ""], function (_ref) {
  var left = _ref.left;
  return left ? " text-align: left;" : "text-align: right;";
});